module.exports = __webpack_public_path__ + "a17d279f/img/SOURCERY_poweredby_web.9819842b.png";